// extracted by mini-css-extract-plugin
var _1 = "BuildingSearchItem-moduleBuildingSearchItem__AYFiz SearchItem-moduleSearchItem__qpbuZ";
export { _1 as "BuildingSearchItem" }
